import { PAGES } from "@dune/types";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
	useGetBrokerProjects,
	useGetBrokerReceipts,
	useGetBrokerTasks,
} from "../../api/queries/dashboard.queries";
import { useGetBrokerDetails, useMe } from "../../api/queries/users.queries";
import ErrorBoundary from "../../component/common/ErrorBoundary";
import { DashboardHeader } from "./components/DashboardHeader";
import { ProjectsSection } from "./components/ProjectsSection";
import { ReceiptsCard } from "./components/ReceiptsCard";
import { TasksSection } from "./components/TasksSection";

const BrokerDashboard: React.FC = () => {
	const navigate = useNavigate();
	const { data: brokerDetails, isLoading, error } = useGetBrokerDetails();
	const { me } = useMe();
	const brokerTasksQuery = useGetBrokerTasks();
	const brokerProjectsQuery = useGetBrokerProjects();
	const brokerReceiptsQuery = useGetBrokerReceipts();

	const handleNewProject = () => {
		navigate(PAGES.PROJECTS.create);
	};

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-xl font-semibold">
					Chargement du tableau de bord...
				</h1>
			</div>
		);
	}

	if (error || !brokerDetails) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-xl font-semibold text-red-600">
					Erreur lors du chargement du tableau de bord
				</h1>
			</div>
		);
	}

	return (
		<div className="h-screen overflow-hidden flex flex-col bg-white rounded-lg border">
			<ErrorBoundary fallbackMessage="Erreur lors du chargement du tableau de bord">
				<div className="flex-shrink-0 p-6 pb-4">
					<DashboardHeader
						firstName={me?.firstname || ""}
						onNewProject={handleNewProject}
					/>
				</div>
				<div className="flex-1 px-6 pb-6 overflow-hidden">
					<div className="h-full grid grid-cols-4 gap-6">
						<div className="col-span-1 flex flex-col gap-4 overflow-hidden">
							<div className="flex-shrink-0">
								<ReceiptsCard
									totalCount={brokerReceiptsQuery.data?.totalCount}
									isLoading={brokerReceiptsQuery.isLoading}
									error={brokerReceiptsQuery.error}
								/>
							</div>
							<div className="flex-1 min-h-0">
								<TasksSection
									tasksData={brokerTasksQuery.data}
									isLoading={brokerTasksQuery.isLoading}
									error={brokerTasksQuery.error}
								/>
							</div>
						</div>
						<div className="col-span-3 min-h-0">
							<ProjectsSection
								projectsData={brokerProjectsQuery.data}
								isLoading={brokerProjectsQuery.isLoading}
								error={brokerProjectsQuery.error}
							/>
						</div>
					</div>
				</div>
			</ErrorBoundary>
		</div>
	);
};

export default BrokerDashboard;
